export class PopoverProps {
    constructor(public labelKey: string, public popoverText: string) {
    }
}